import lang from '../../../../../lib/language';
import { TradingPlan } from '../../../../../lib/models/crm/types';
import { getCurrencySymbolByCurrencyCode } from '../../../../../lib/util/DataHelpers';

import { MobileDrawer } from '../../../../../components';
import { useIsMobile } from '../../../../../hooks';
import Button from '../../../../../shared_components/Button/Button';

import styles from './SelectedPlan.module.scss';

type Props = {
  selectedPlan: TradingPlan;
  withAutoPass?: boolean;
  isDetailsOpen?: boolean;
  onCloseDetails?: () => void;
};

const SelectedPlan = ({
  selectedPlan,
  withAutoPass,
  isDetailsOpen,
  onCloseDetails,
}: Props): JSX.Element => {
  const { isMobile } = useIsMobile();

  const currencySymbol = getCurrencySymbolByCurrencyCode(selectedPlan.plan_price_ccy);
  const accountSize = selectedPlan.daily_hard_bp ?? 0;
  const maxDrawdown = selectedPlan.maximum_total_loss ?? 0;
  const maxDrawdownAmount = selectedPlan.maximum_total_loss_amount ?? 0;

  const detailsRows = (
    <div className={styles.planDetails}>
      <div className={styles.planRow}>
        <div className={styles.planLabel}>{lang.accountSize()}</div>
        <div className={styles.planValue}>
          {currencySymbol}
          {accountSize.toLocaleString()}
        </div>
      </div>
      <div className={styles.planRow}>
        <div className={styles.planLabel}>{lang.maxDrawdown()}</div>
        <div className={styles.planValue}>
          {maxDrawdown}
          {'% ('}
          {currencySymbol}
          {maxDrawdownAmount.toLocaleString()}
          {')'}
        </div>
      </div>
      <div className={styles.planRow}>
        <div className={styles.planLabel}>{lang.autoPass()}</div>
        <div className={styles.planValue}>
          {withAutoPass
            ? lang.cryptoPaymentAutoPassActive()
            : lang.cryptoPaymentAutoPassInactive()}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {!isMobile && detailsRows}
      {isMobile && (
        <MobileDrawer
          isOpen={!!isDetailsOpen}
          usePortal
          title={lang.cryptoPaymentSelectedPlanTitle()}
          onClose={() => onCloseDetails?.()}
        >
          {detailsRows}
          <Button
            fullWidth
            biggerFontSize
            className={styles.closeButton}
            onClick={() => onCloseDetails?.()}
          >
            {lang.commonClose()}
          </Button>
        </MobileDrawer>
      )}
    </>
  );
};

export default SelectedPlan;
